"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _chromaJs = _interopRequireDefault(require("chroma-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var red = (0, _chromaJs["default"])('#F44336');
var pink = (0, _chromaJs["default"])('#E91E63');
var purple = (0, _chromaJs["default"])('#9C27B0');
var deepPurple = (0, _chromaJs["default"])('#673AB7');
var indigo = (0, _chromaJs["default"])('#3F51B5');
var blue = (0, _chromaJs["default"])('#2196F3');
var lightBlue = (0, _chromaJs["default"])('#03A9F4');
var cyan = (0, _chromaJs["default"])('#00BCD4');
var teal = (0, _chromaJs["default"])('#009688');
var green = (0, _chromaJs["default"])('#4CAF50');
var lightGreen = (0, _chromaJs["default"])('#8BC34A');
var lime = (0, _chromaJs["default"])('#CDDC39');
var yellow = (0, _chromaJs["default"])('#FFEB3B');
var amber = (0, _chromaJs["default"])('#FFC107');
var orange = (0, _chromaJs["default"])('#FF9800');
var deepOrange = (0, _chromaJs["default"])('#FF5722');
var brown = (0, _chromaJs["default"])('#795548');
var gray = (0, _chromaJs["default"])('#9E9E9E');
var blueGray = (0, _chromaJs["default"])('#607D8B');
var _default = {
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  gray: gray,
  blueGray: blueGray
};
exports["default"] = _default;